import { FC, FormEvent } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import SearchIcon from '@/components/icons/SearchIcon';
import { cn } from '@/lib/utils';

type Props = {
	placeholder?: string;
	className?: string;
	containerClassName?: string;
	disabled?: boolean;
	value: string;
	setValue: (e: string) => void;
	onSearch?: () => void;
};

const ESearchInput: FC<Props> = ({
	placeholder = 'Search',
	className,
	containerClassName,
	disabled,
	value,
	setValue,
	onSearch,
}) => {
	const handleSubmit = (event: FormEvent) => {
		event.preventDefault();
		onSearch?.();
	};

	return (
		<form
			className={cn(`relative w-full ${containerClassName}`)}
			onSubmit={handleSubmit}>
			<Input
				className={`pr-9 ${className}`}
				placeholder={placeholder}
				disabled={disabled}
				value={value}
				onChange={(e) => setValue?.(e.target.value)}
			/>
			<Button
				variant='link'
				type='submit'
				className={
					'absolute right-2.5 top-1/2 -translate-y-1/2 h-fit p-0'
				}>
				<SearchIcon />
			</Button>
		</form>
	);
};

export default ESearchInput;
